import "./CardsProfsActifs.css";
import React from "react";
import ListGroup from 'react-bootstrap/ListGroup';
import html from "../../Assets/html.jpg"
import { BiDotsVerticalRounded } from 'react-icons/bi'
import { MdDeleteOutline } from 'react-icons/md'
import { FaRegEdit } from 'react-icons/fa'
import {Dropdown } from "react-bootstrap";
import ButtonGroup from 'react-bootstrap/ButtonGroup';


function template({ titres }) {
  return (
    <div id="cardsProfsActifs" className="p-3">
          <ListGroup.Item className="d-flex justify-content-between">
            <div className=" d-flex">
              <div>
                <img src={html} alt={"images"} className="imgCPA" />
              </div>
              <div className="ps-3">
                <h6 className="fw-blod">Omar Gaye</h6>
                <p className="small">6 Cours 50,724 Students <br />12.000 vues</p>
              </div>
            </div>
            <Dropdown className="dropdow132" as={ButtonGroup}>
              <Dropdown.Toggle id="dropdown-custom-1">
                <BiDotsVerticalRounded className="icon132 " />
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors dropdow133">
                <h6 className="text-center">Setting</h6>
                <Dropdown.Item eventKey="1"><FaRegEdit /> Edit</Dropdown.Item>
                <Dropdown.Item eventKey="2"><MdDeleteOutline /> Remove</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </ListGroup.Item>
          <hr />
          
    </div>
  );
}

export default template;
